module.exports = __webpack_public_path__ + "img/logo.f81ce9f7.svg";